// ViewSelectorOptions.js

import { sortViewsByConfiguredOrder } from './ViewOrder';

const DEFAULT_ADD_OPTION_ID = '__add_view__';
const DEFAULT_ADD_OPTION_LABEL = '+ Add View';

export function buildViewSelectorOptions(
  views,
  {
    fallbackType = 'TABLE',
    includeAddOption = false,
    addOptionId = DEFAULT_ADD_OPTION_ID,
    addOptionLabel = DEFAULT_ADD_OPTION_LABEL,
  } = {}
) {
  const base = sortViewsByConfiguredOrder(views)
    .map((view) => {
      const id = String(view?.key || view?.id || '').trim();
      if (!id) return null;

      const label = String(view?.title || view?.label || '').trim() || 'Untitled View';
      const note = String(view?.description || '').trim();
      const type = String(view?.type || fallbackType).trim().toUpperCase() || fallbackType;

      return {
        id,
        label,
        note: note || undefined,
        type,
        view,
      };
    })
    .filter(Boolean);

  if (!includeAddOption) return base;

  return [
    ...base,
    { id: addOptionId, label: addOptionLabel },
  ];
}

export function getActiveSelectorOption(options, activeId) {
  return (Array.isArray(options) ? options : []).find((option) => option.id === activeId) || null;
}

export function getActiveSelectorLabel(options, activeId, fallbackLabel = 'Select View') {
  const active = getActiveSelectorOption(options, activeId);
  return active?.label || fallbackLabel;
}
